// extracted by mini-css-extract-plugin
module.exports = {"gallery-wrapper":"Item_gallery-wrapper__2LuBL","gallery":"Item_gallery__1-kIO","media":"Item_media__1h0UM","content":"Item_content__3fG0M"};